import React from "react";
import HeroBD from "../../components/placement_test/identify/HeroBD";
import IdentityForm from "../../components/placement_test/identify/IdentityForm";

const BiodataPage = () => {
  return (
    <div className="st-surface-cream overflow-x-hidden px-4 pb-6 pt-8 sm:px-6 md:pt-10">
      <div className="mx-auto max-w-5xl">
        <HeroBD />
        <IdentityForm />
      </div>
    </div>
  );
};

export default BiodataPage;
